import { differenceInDays, differenceInMinutes } from "date-fns";

export const calculateTimeSlotConditions = (timeSlot, date, today, todayWithTime) => {
  const diffDays = differenceInDays(date, today);
  
  const [hours] = timeSlot.split(':').map(Number);
  const dateWithMinutes = new Date(date).setHours(hours);
  const diffMinutes = differenceInMinutes(dateWithMinutes, todayWithTime);
  
  return { diffDays, diffMinutes };
};